import React, { useState, useEffect, useRef } from 'react';
import MenuItems from './MenuItems';
import MobileMenu from './MobileMenu';
import { MenuIcon } from '../../artwer/icons';
import navImg from "../../../assets/images/artwer/logo-dark-text.png";

const HeaderStyleTwo = (props) => {
    const { parentMenu, secondParentMenu, activeMenu } = props;
    const [isMobileMenu, setMobileMenu] = useState(false);
    const headerRef = useRef(null);

    const handleMobileMenu = () => {
        setMobileMenu(!isMobileMenu);
        if (!isMobileMenu) {
            document.body.classList.add("mobile-menu-visible");
        } else {
            document.body.classList.remove("mobile-menu-visible");
        }
    }

    // Mobile drawer: lock body scroll while open, close on Escape, and move
    // focus to the close button so keyboard users aren't left behind the menu.
    useEffect(() => {
        if (!isMobileMenu) return;
        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        const closeBtn = document.querySelector('.mobile-nav__close');
        if (closeBtn) closeBtn.focus();
        const onKey = (e) => { if (e.key === 'Escape') handleMobileMenu(); };
        document.addEventListener('keydown', onKey);
        return () => {
            document.body.style.overflow = prevOverflow;
            document.removeEventListener('keydown', onKey);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isMobileMenu]);

    // The header is position:fixed, so reserve its exact height on the body to
    // avoid hiding the hero (recomputed on resize for responsive header heights).
    useEffect(() => {
        const setPad = () => {
            const h = headerRef.current ? headerRef.current.offsetHeight : 0;
            document.body.style.paddingTop = h + "px";
        };
        setPad();
        window.addEventListener("resize", setPad);
        const t = setTimeout(setPad, 500); // re-measure after fonts/layout settle
        return () => { window.removeEventListener("resize", setPad); clearTimeout(t); };
    }, []);

    const renderNav = () => (
        <nav className="main-menu main-menu-two" aria-label="Hoofdnavigatie">
            <div className="main-menu-two__wrapper">
                <div className="container">
                    <div className="main-menu-two__wrapper-inner">
                        <div className="main-menu-two__left">
                            <div className="main-menu-two__logo">
                                <a href="#home">
                                    <img src={navImg} alt="ART-WER" />
                                </a>
                            </div>
                        </div>
                        <div className="main-menu-two__right">
                            <div className="main-menu-two__main-menu-box">
                                <a
                                    href="tel:+31616136942"
                                    className="artwer-header-call"
                                    aria-label="Bel ART-WER: +31 6 16 13 69 42"
                                >
                                    <span className="icon-call" aria-hidden="true"></span>
                                </a>
                                <button
                                    type="button"
                                    className="mobile-nav__toggler"
                                    onClick={handleMobileMenu}
                                    aria-label={isMobileMenu ? 'Menu sluiten' : 'Menu openen'}
                                    aria-expanded={isMobileMenu}
                                >
                                    <MenuIcon />
                                </button>
                                <ul className="main-menu__list">
                                    <MenuItems
                                        parentMenu={parentMenu}
                                        secondParentMenu={secondParentMenu}
                                        activeMenu={activeMenu}
                                    />
                                </ul>
                            </div>
                            <div className="main-menu-two__search-btn-box">
                                <div className="main-menu-two__btn-box">
                                    <a href="#contact" className="thm-btn-two main-menu-two__btn">
                                        Offerte aanvragen<span className="icon-dubble-arrow-right"></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );

    return (
        <React.Fragment>
            <header ref={headerRef} className="main-header-two">
                {renderNav()}

                <MobileMenu handleMobileMenu={handleMobileMenu} />
            </header>
        </React.Fragment>
    );
}

export default HeaderStyleTwo;
